import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardingComponent } from './onboarding.component';
import { Routes, RouterModule } from '@angular/router';
import { QuestionsComponent } from './questions/questions.component';
import { TileQuestionComponent } from './questions/_subs/tile-question/tile-question.component';
import { PillQuestionComponent } from './questions/_subs/pill-question/pill-question.component';
import { FundComponent } from './fund/fund.component';
import { AmountComponent } from './fund/_subs/amount/amount.component';
import { DistributionComponent } from './fund/_subs/distribution/distribution.component';
import { PaymentComponent } from './fund/_subs/payment/payment.component';
import {
    NgbDropdownModule,
    NgbCollapseModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgxCurrencyModule } from 'ngx-currency';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RiskProfileComponent } from './risk-profile/risk-profile.component';
import { SuccessModalComponent } from './success-modal/success-modal.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../../../shared/interceptors/auth.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import { KycComponent } from './kyc/kyc/kyc.component';
import { InputComponent } from './kyc/fields/input/input.component';
import { SelectComponent } from './kyc/fields/select/select.component';
import { PillsComponent } from './kyc/fields/pills/pills.component';
import { ImageComponent } from './kyc/fields/image/image.component';
import { Angular4PaystackModule } from 'angular4-paystack';
import { OtpComponent } from './kyc/fields/otp/otp.component';
import { CoreModule } from 'src/app/core/core.module';
import { PartialsModule } from '../../partials/partials.module';
import { FlowMenuComponent } from './flow-menu/flow-menu.component';
import { UserComponent } from './user/user.component';

const routes: Routes = [
    {
        path: '',
        component: OnboardingComponent,
        children: [
            {
                path: '',
                redirectTo: 'menu',
                pathMatch: 'full',
            },
            {
                path: 'menu',
                component: FlowMenuComponent
             
            },
            {
                path: 'suitability',
                component: QuestionsComponent,
            },
            {
                path: 'risk-profile',
                component: RiskProfileComponent,
            },
            {
                path: 'fund',
                component: FundComponent,
            },
            {
                path: 'success',
                component: SuccessModalComponent,
            },
            {
                path: 'kyc',
                component: KycComponent,
            },
            {
                path: 'user-details',
                component: UserComponent,
            },

        ],
    },
];

@NgModule({
    declarations: [
        OnboardingComponent,
        QuestionsComponent,
        TileQuestionComponent,
        PillQuestionComponent,
        FundComponent,
        AmountComponent,
        DistributionComponent,
        PaymentComponent,
        RiskProfileComponent,
        SuccessModalComponent,
        KycComponent,
        InputComponent,
        SelectComponent,
        PillsComponent,
        ImageComponent,
        OtpComponent,
        FlowMenuComponent,
        UserComponent,
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        NgbDropdownModule,
        GooglePlaceModule,
        NgbCollapseModule,
        NgxCurrencyModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgxSpinnerModule,
        CoreModule,
        PartialsModule,
        Angular4PaystackModule.forRoot(
            'pk_test_e5bb55d844be42b8e2d3aad9304af2e2bc8eae0d'
        ),
    ],
    schemas:[CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ],
})
export class OnboardingModule {}
